import React from "react";
import { Box, Divider } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { useOutletContext } from "react-router-dom";
import { OrderItemCard } from "../../../components/OrderItemCard";
import { Body } from "../../../components/Typography";
import { OrderViewV2OutletContext } from "../OrderViewV2";

export const OrderItemsTab: React.FC = () => {
  const { order } = useOutletContext<OrderViewV2OutletContext>();
  const orderItems = order?.orderItems ?? [];

  if (orderItems.length === 0) {
    return (
      <Box sx={{ padding: tokens.spacing[4] }}>
        <Body>No items found for this order.</Body>
      </Box>
    );
  }

  const heading = orderItems.length === 1 ? "1 Item" : `${orderItems.length} Items`;

  return (
    <Box sx={{ padding: tokens.spacing[4], display: "flex", flexDirection: "column", gap: tokens.spacing[6] }}>
      <Body>{heading}</Body>
      {orderItems.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 && <Divider sx={{ borderColor: tokens.color.semantic.bg.surfaceSunken }} />}
          <OrderItemCard orderItem={item} />
        </React.Fragment>
      ))}
    </Box>
  );
};
